import { EnumButtonName, EventProperties } from '@calm/evexia-analytics';
import { Close } from '@mui/icons-material';
import commonMessages from '@rhg/lang/messages/common';
import { IconButton, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { useIntl } from 'react-intl';

const styleCloseButton = {
    borderRadius: '50%',
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'mask.white.80p' : 'mask.black.40p',
    color: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'action.active' : 'primary.main',
    zIndex: 1,
};
const styleCloseButtonFullScreen = {
    color: 'primary.main',
};

interface DialogCloseButtonProps {
    sx?: SxProps<Theme>;
    trackButton?: EnumButtonName;
    trackProps?: EventProperties;
    isFullScreen?: boolean;
    onClick: () => void;
}

export function DialogCloseButton({
    sx,
    trackButton = 'Close',
    trackProps,
    isFullScreen,
    onClick,
}: DialogCloseButtonProps) {
    const { formatMessage } = useIntl();

    return (
        <IconButton
            sx={sxAppend(
                sx,
                styleCloseButton,
                isFullScreen && styleCloseButtonFullScreen
            )}
            aria-label={formatMessage(commonMessages['common.dismiss_dialog'])}
            onClick={onClick}
            size={isFullScreen ? 'large' : 'small'}
            trackButton={trackButton}
            trackProps={trackProps}
        >
            <Close />
        </IconButton>
    );
}
